
        Component.define('page-products-internal', (el, params) => {
            /**
 * O componente Each recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

$el                 = $(el);
$buttonSizes        = $el.find('.size-tag');
$buttonWhereToFind  = $el.find('.btn-where-to-find');
$photoGallery       = $('[data-component="photo-gallery"]');

$buttonWhereToFind.on('click', function(e){
    const url = $(this).attr('href');

    $document.trigger('ga-comprar-online:click', [url]);
});

$buttonSizes.on('click', function(e){
    const index = $(this).data('gallery');

    $photoGallery.trigger('slider:goto', [index]);
});



if($el.find('.prod-type-bifinhos').length > 0){


}

        });